(function(){
  'use strict';

  angular.module('eclipseApp.core').controller('changeInternetPromoWarningModalCtrl', ['$scope', '$modalInstance', '$state', 'accountDashboardManager', 'notifier', '$rootScope', '$modal', function($scope, $modalInstance, $state, accountDashboardManager, notifier, $rootScope, $modal){

    $scope.ok = function(){
      var respKey = 'reviewChangeInternetPkg';
      $modalInstance.dismiss();

      notifier.notify.processing();

      // fetch order summary
      accountDashboardManager.reviewChangeInternetPackage().then(function(resp){
        if(resp && resp[respKey] && resp[respKey]) {

          notifier.notify.done();

          // extend checoutSession.review with data response to display to ui
          angular.extend(accountDashboardManager.checkoutSession.review, {data: resp[respKey]});
          accountDashboardManager.setSession('checkoutSession', accountDashboardManager.checkoutSession);

          // if there is no error procceed to review page
          $state.go('myAccount.internet.package.change.review');

          // $scope.review.tier = resp[respKey].packageAdded;
          
          // TODO
          // fix scoping of data that caters to both buy-flow and change-internet-pckg
          // $scope.reviewData = $scope.review = resp[respKey];
        }
        else {
          if (resp && resp.error && resp.error === '237001') {
            notifier.notify.custom();
          } else if (resp && resp.error) {
            notifier.notify.error({errorCode: resp.error});
          } else {
            notifier.notify.error();
          }
        }
      }, function(errorData){
        console.log('accountDashboardManager.reviewChangeInternetPackage() --error', errorData);
        var _errorCode = (errorData && errorData[respKey] && errorData[respKey].error) || errorData.error;
        if (_errorCode === '237001') {

          var options = {};

          notifier.notify.done();
          
          options.templateUrl = 'modules/my-account/internet/cannot-proceed-modal.html';
          options.controller = options.controller || ['$scope', '$modalInstance', function($scope, $modalInstance){
            $scope.cancel = function(){
              $modalInstance.close();
            };
            $scope.ok = function(){
              $modalInstance.close();
            };
          }];

          $modal.open(options);
        } else if (_errorCode) {
          notifier.notify.error({errorCode: _errorCode});
        } else {
          notifier.notify.error();
        }
      });
    };

    $scope.dismiss = function(){
      $modalInstance.dismiss();
    };
  }]);
})();
